module.exports = __webpack_public_path__ + "img/vi-logo.072a038e.png";